import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgmatModule } from "src/app/shared-module/ngmat/ngmat.module";
import { RoutingModule } from "./routing.module";
import { AngularFontAwesomeModule } from "angular-font-awesome";
import { ValidatingEnrolleeComponent } from './component/validating-enrollee/validating-enrollee.component';
import { CustomModule } from 'src/app/shared-module/custom/custom.module';
import { FileUploadModule } from "ng2-file-upload";
import { DocViewerModule } from 'src/app/shared-module/doc-viewer/doc-viewer.module';
import { GroupHRListComponent } from './component/group-hr-list/group-hr-list.component';
import { DialogGroupHrListComponent } from './component/group-hr-list/dialog-group-hr-list/dialog-group-hr-list.component';
import { AdditionalDocumentSubmissionComponent } from './component/additional-document-submission/additional-document-submission.component';
import { ClaimSubmissionComponent } from './component/claim-submission/claim-submission.component';
import { UploadDocumentComponent } from './component/upload-document/upload-document.component';
import { ValidateClaimComponent } from './component/validate-claim/validate-claim.component';
import { OnlineDocumentUploadComponent } from './component/online-document-upload/online-document-upload.component';
import { ValidateEnrolComponent } from './component/validate-enrol/validate-enrol.component';
import { OnlineClaimSubmissionComponent } from './component/online-claim-submission/online-claim-submission.component';
import { OnlineGenerateInputComponent } from './component/online-generate-input/online-generate-input.component';
import { NewCaseApprovalComponent } from './component/new-case-approval/new-case-approval.component';
import { PpoListComponent } from './component/ppo-list/ppo-list.component';
import { ViewletterDialogComponent } from './component/ppo-list/viewletter-dialog/viewletter-dialog.component';
import { HrDashboardComponent } from './component/hr-dashboard/hr-dashboard.component';
import { DialogeDashboardDetailComponent } from './component/hr-dashboard/dialoge-dashboard-detail/dialoge-dashboard-detail.component';
import { ClaimSubmissionIndComponent } from './component/claim-submission-ind/claim-submission-ind.component';
import { OnlineClaimSubmissionIndComponent } from './component/online-claim-submission-ind/online-claim-submission-ind.component';
import { AuthenticateClaimSubmitterComponent } from './component/authenticate-claim-submitter/authenticate-claim-submitter.component';
import { ValidatePolicyDataComponent } from './component/validate-policy-data/validate-policy-data.component';
import { OnlineDocumentUploadIndComponent } from './component/online-document-upload-ind/online-document-upload-ind.component';
import { AdditionalDocumentSubmissionIndComponent } from "./component/additional-document-submission-ind/additional-document-submission-ind.component";
import { ValidateClaimIndComponent } from "./component/validate-claim-ind/validate-claim-ind.component";
import { OnlineAdditionalDocumentUploadIndComponent } from './component/online-additional-document-upload-ind/online-additional-document-upload-ind.component';
import { ClaimSubmissionGlComponent } from './component/claim-submission-gl/claim-submission-gl.component';
import { OnlineClaimSubmissionGlComponent } from './component/online-claim-submission-gl/online-claim-submission-gl.component';
import { OnlineGenerateInputGlComponent } from "./component/online-generate-input-gl/online-generate-input-gl.component";
import { OnlineDocumentUploadBancaComponent } from './component/online-document-upload-banca/online-document-upload-banca.component';
import { OnlineDocumentUploadGlComponent } from './component/online-document-upload-gl/online-document-upload-gl.component';
import { ClaimSubmissionBancaComponent } from './component/claim-submission-banca/claim-submission-banca/claim-submission-banca.component';
import { OnlineClaimSubmissionBancaComponent } from './component/online-claim-submission-banca/online-claim-submission-banca/online-claim-submission-banca.component';
import { OnlineGenerateInputBancaComponent } from './component/online-generate-input-banca/online-generate-input-banca/online-generate-input-banca.component';
import { AdditionalDocumentSubmissionBancaComponent } from './component/additional-document-submission-banca/additional-document-submission-banca.component';
import { ValidateClaimBancaComponent } from './component/validate-claim-banca/validate-claim-banca.component';
import { AdditionalDocumentSubmissionGlComponent } from './component/additional-document-submission-gl/additional-document-submission-gl/additional-document-submission-gl.component';
import { ValidateClaimGlComponent } from './component/validate-claim-gl/validate-claim-gl/validate-claim-gl.component';
import { OnlineDocumentUploadBancaGlComponent } from './component/online-document-upload-banca-gl/online-document-upload-banca-gl/online-document-upload-banca-gl.component';
import { OnlineDocumentUploadPpoComponent } from './component/online-document-upload-ppo/online-document-upload-ppo.component';
import { NigoDocumentUploadPPOComponent } from "./component/nigo-document-upload-ppo/nigo-document-upload-ppo.component";
import { EbDashboardLoginComponent } from "./component/eb-dashboard-login/eb-dashboard-login.component";
import { HrDashboardClaimsReportComponent } from './component/hr-dashboard-claims-report/hr-dashboard-claims-report.component';
import { EbEmployeeDashboardDetailsComponent } from "./component/eb-employee-dashboard-details/eb-employee-dashboard-details/eb-employee-dashboard-details.component";
import { EbEmployeeClaimDetailsComponent } from "./component/eb-employee-claim-details/eb-employee-claim-details.component";
import { EbDashboardEmployeeBasicInfoComponent } from "./component/eb-dashboard-employee-basic-info/eb-dashboard-employee-basic-info.component";
import { EbDashboardEmployeeClaimStatusComponent } from "./component/eb-dashboard-employee-Claim-Status/eb-dashboard-employee-Claim-Status.component";
import { DialogEbClaimStatusDetailsComponent } from "./component/eb-employee-claim-details/dialog-eb-claim-status-details/dialog-eb-claim-status-details.component";
import { DialogClaimUsageEmailDiseaseDetailsComponent } from './component/eb-employee-dashboard-details/eb-employee-dashboard-details/dialog-claim-usage-email-disease-details/dialog-claim-usage-email-disease-details.component';
import { DialogAllClaimReportComponent } from './component/hr-dashboard/dialog-all-claim-report/dialog-all-claim-report.component';
import { DialogEnrolMedicalCardEmailComponent } from "./component/eb-employee-dashboard-details/dialog-enrol-medical-card-email/dialog-enrol-medical-card-email.component";
import { HrClaimStatusComponent } from './component/hr-claim-status/hr-claim-status.component';
@NgModule({
  declarations: [
    ValidatingEnrolleeComponent,
    GroupHRListComponent,
    DialogGroupHrListComponent,
    AdditionalDocumentSubmissionComponent,
    ClaimSubmissionComponent,
    UploadDocumentComponent,
    ValidateClaimComponent,
    OnlineDocumentUploadComponent,
    ValidateEnrolComponent,
    OnlineClaimSubmissionComponent,
    OnlineGenerateInputComponent,
    NewCaseApprovalComponent,
    PpoListComponent,
    ViewletterDialogComponent,
    HrDashboardComponent,
    DialogeDashboardDetailComponent,
    ClaimSubmissionIndComponent,
    OnlineClaimSubmissionIndComponent,
    AuthenticateClaimSubmitterComponent,
    ValidatePolicyDataComponent,
    OnlineDocumentUploadIndComponent,
    AdditionalDocumentSubmissionIndComponent,
    ValidateClaimIndComponent,
    OnlineAdditionalDocumentUploadIndComponent,
    ClaimSubmissionGlComponent,
    OnlineClaimSubmissionGlComponent,
    OnlineGenerateInputGlComponent,
    OnlineDocumentUploadBancaComponent,
    OnlineDocumentUploadGlComponent,
    ClaimSubmissionBancaComponent,
    OnlineClaimSubmissionBancaComponent,
    OnlineGenerateInputBancaComponent,
    AdditionalDocumentSubmissionBancaComponent,
    ValidateClaimBancaComponent,
    AdditionalDocumentSubmissionGlComponent,
    ValidateClaimGlComponent,
    OnlineDocumentUploadBancaGlComponent,
    OnlineDocumentUploadPpoComponent,
    NigoDocumentUploadPPOComponent,
    EbDashboardLoginComponent,
    HrDashboardClaimsReportComponent,
    EbEmployeeDashboardDetailsComponent,
    EbEmployeeClaimDetailsComponent,
    EbDashboardEmployeeBasicInfoComponent,
    EbDashboardEmployeeClaimStatusComponent,
    DialogEbClaimStatusDetailsComponent,
    DialogClaimUsageEmailDiseaseDetailsComponent,
    DialogAllClaimReportComponent,
    DialogEnrolMedicalCardEmailComponent,
    HrClaimStatusComponent,
  ],
  imports: [
  CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgmatModule,
    RoutingModule,
    AngularFontAwesomeModule,
    FileUploadModule,
    CustomModule,
    DocViewerModule
  ],
  entryComponents: [
    DialogGroupHrListComponent,
    ViewletterDialogComponent,
    DialogeDashboardDetailComponent,
    DialogEbClaimStatusDetailsComponent,
    DialogEnrolMedicalCardEmailComponent,
    DialogClaimUsageEmailDiseaseDetailsComponent,
    DialogAllClaimReportComponent
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductModule { }
